import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Constants } from '../core/constants';
import { ContextService } from '../core/context.service';

@Component({
  selector: 'tv-list-actions',
  templateUrl: './list.actions.component.html'
})
export class ListActionsComponent implements OnInit {
  private detailUrl: string;
  private isNewEnabled: boolean;

  constructor(private route: ActivatedRoute, private router: Router,
    private constants: Constants, private contextService: ContextService) {
  }

  ngOnInit() {
    console.log('List Actions route snap shot ', this.route.snapshot.data);
    this.detailUrl = `${this.router.routerState.snapshot.url}/detail/-1`;

    const screens = this.route.snapshot.data['screens'];
    this.isNewEnabled = this.contextService.hasActionPermission(screens, this.constants.ScreenAction.Create);
  }

  newItem() {
      this.router.navigate([this.detailUrl]);
  }
}
